(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["subscription-upsell-popup"] && !Shopify.designMode) return;
  try {
    
(function() {
  var popup = document.getElementById("sub-upsell-popup");
  if (!popup) return;
  if (sessionStorage.getItem("sub-upsell-dismissed")) return;

  fetch("/cart.js")
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      console.log("[sub-upsell] cart items:", cart.items.map(function(i){ return i.title; }));
      var hasSub = cart.items.some(function(item) {
        return item.title.toLowerCase().includes("subscription");
      });
      console.log("[sub-upsell] hasSub:", hasSub);
      if (!hasSub) return;
      popup.classList.add("is-visible");
    });

  function close() {
    popup.classList.remove("is-visible");
    sessionStorage.setItem("sub-upsell-dismissed", "1");
  }
  document.getElementById("sub-upsell-close").addEventListener("click", close);
  document.getElementById("sub-upsell-overlay").addEventListener("click", close);
  document.getElementById("sub-upsell-dismiss").addEventListener("click", close);
  document.addEventListener("keydown", function(e) { if (e.key === "Escape") close(); });
})();


  } catch(e) { console.error(e); }
})();
})();
